import React from 'react'

import { nonEmbeddedAttachments } from 'util/changesets'
import Attachments from 'components/Attachments'

import Header from './Header'
import Body from './Body'
import TrackingDetails from './TrackingDetails'

import { getAvatarComponent } from './util'

const ExpandedNoteContent = ({
  message,
  expandChangeset,
  currentUserId,
  isFirstMessage,
  onOpenImage,
  onCopyLinkClick,
  onPrintClick,
}) => {
  const action = message.action
  const hasAttachments = message.hasAttachments
  const isFromMerge = message.isFromMerge
  const isForward = message.isForward
  const readReceipt = message.readReceipt

  const change = action.change
  const isNote = message.isNote
  const isBodyEmpty = change.isBodyEmpty
  const filtered = nonEmbeddedAttachments(change)

  return (
    <React.Fragment>
      <div className="header-body-container">
        {getAvatarComponent({ action })}
        <div className="note-header-body">
          <div onClick={expandChangeset}>
            <Header
              action={action}
              currentUserId={currentUserId}
              isNote={isNote}
              isFirstMessage={isFirstMessage}
              isForward={isForward}
              hasAttachments={hasAttachments}
              isFromMerge={isFromMerge}
              hasRawEmail={message.hasRawEmail}
              onCopyLinkClick={onCopyLinkClick}
              onPrintClick={onPrintClick}
              readReceipt={readReceipt}
            />
          </div>
          <div>
            <Body
              change={change}
              isForward={isForward}
              isFirstMessage={isFirstMessage}
              onOpenImage={onOpenImage}
            />
          </div>
        </div>
      </div>
      <div className="bottom-side">
        <Attachments
          attachments={isBodyEmpty ? change.attachments : filtered}
        />
        {isFirstMessage && <TrackingDetails />}
      </div>
    </React.Fragment>
  )
}

export default ExpandedNoteContent
